export const idx_data_suggested_layout = [];

idx_data_suggested_layout.push({layoutType: "dual_angle", name: "Max Flip: 70 x 3 1/2 x 20", value: "70 X 3 1/2 X 20" });

idx_data_suggested_layout.push({ layoutType: "dual_angle", name: "Most Versatile: 45 x 4 x 35", value: "45 X 4 X 35" });

idx_data_suggested_layout.push({ layoutType: "dual_angle", name: "Smoother Motion: 20 x 4 1/2 x 40", value: "20 X 4 1/2 X 40" });

idx_data_suggested_layout.push({ layoutType: "dual_angle", name: "Midlane Hook: 40 x 4 1/4 x 75", value: "40 X 4 1/4 X 75" });

idx_data_suggested_layout.push({ layoutType: "dual_angle", name: "Smaller Hook: 90 x 2 1/4 x 45", value: "90 X 2 1/4 X 45" });

idx_data_suggested_layout.push({layoutType: "vls", name: "High Flaring: 4 x 4 x 2", value: "4 X 4 X 2"});

idx_data_suggested_layout.push({layoutType: "vls", name: "Deep Inside Line: 5 x 4 x 3", value: "5 X 4 X 3"});

idx_data_suggested_layout.push({layoutType: "vls", name: "Long Pattern: 3 1/2 x 5 x 3", value: "3 1/2 X 5 X 3"});
          
idx_data_suggested_layout.push({layoutType: "vls", name: "Control Style: 5 x 3 x 4", value: "5 X 3 X 4"});

idx_data_suggested_layout.push({layoutType: "2ls", name: "Low Flaring: 5 1/2 x 5 x 2", value: "5 1/2 X 5 X 2"});
          
idx_data_suggested_layout.push({layoutType: "2ls", name: "Rev Dominant: 2 x 6 x 5", value: "2 X 6 X 5"});
          
idx_data_suggested_layout.push({layoutType: "2ls", name: "Beginner Friendly: 5 x 4 x 3 1/2", value: "5 X 4 X 3 1/2"});
          
idx_data_suggested_layout.push({layoutType: "2ls", name: "High Oil Volume: 4 1/2 x 3 x 4 1/2", value: "4 1/2 X 3 X 4 1/2"});
          
idx_data_suggested_layout.push({layoutType: "2ls", name: "Transitionary: 4 x 4 x 5", value: "4 X 4 X 5"});
          
idx_data_suggested_layout.push({layoutType: "2ls", name: "Speed Dominant: 3 1/2 x 4 x 6 1/2", value: "3 1/2 X 4 X 6 1/2"});

idx_data_suggested_layout.push({layoutType: "pal", name: "Smooth: 5 x 5 x 1", value: "5 X 5 X 1"});
          
idx_data_suggested_layout.push({layoutType: "pal", name: "Angular: 4 1/2 x 6 x 3", value: "4 1/2 X 6 X 3"});
          
idx_data_suggested_layout.push({layoutType: "pal", name: "Strong: 4 x 5 x 2", value: "4 X 5 X 2"});
          
idx_data_suggested_layout.push({layoutType: "pal", name: "Short Pin: 2 1/4 x 6 1/2 x 1", value: "2 1/4 X 6 1/2 X 1"});
          
idx_data_suggested_layout.push({layoutType: "pal", name: "Super short pin: 1 1/4 x 6 1/2 x 1/2", value: "1 1/4 X 6 1/2 X 1/2"});
